import React, { useState } from "react";
import classes from "./FileRow.module.css";
import { Models, TemporaryModels } from "@prisma/client";
import { SelectedState } from "../../../pages/FileSystemPage";
import { useAppSelector } from "../../../app/hooks/hooks";
import { selectUser } from "../../../app/features/auth/authSlice";
import { useNavigate } from "react-router-dom";
import RemainTimeCounter from "./RemainTimeCounter";
import FileVersions from "./FileVersions";
interface FileRowProps {
    file: Models | TemporaryModels;
    setSelectedState: React.Dispatch<React.SetStateAction<SelectedState>>;
    selectedState: SelectedState;
    version: number;
    update: () => void;
}
function FileRow({
    file,
    setSelectedState,
    selectedState,
    version,
    update,
}: FileRowProps) {
    const [showVersions, setShowVersions] = useState<boolean>(false);
    const currentUser = useAppSelector(selectUser);
    const navigate = useNavigate();
    const selected = !!selectedState[file.model_id];
    const getDate = () => {
        const curDate = new Date(file.load_date);
        const dd =
            curDate.getDate() > 9
                ? `${curDate.getDate()}`
                : `0${curDate.getDate()}`;
        const mm =
            curDate.getMonth() + 1 > 9
                ? `${curDate.getMonth() + 1}`
                : `0${curDate.getMonth() + 1}`;
        const yy = curDate.getFullYear();
        return `${dd}.${mm}.${yy}`;
    };

    return (
        <div
            className={[classes.fileRow, selected ? classes.selected : ""].join(
                " "
            )}
            onClick={(e) => {
                e.stopPropagation();
                setSelectedState((selectedState) => {
                    if (selectedState[file.model_id]) {
                        delete selectedState[file.model_id];
                    } else {
                        selectedState[file.model_id] = file.progress;
                    }
                    return { ...selectedState };
                });
            }}
            onDoubleClick={() => {
                const user_id = currentUser
                    ? currentUser.id
                    : localStorage.getItem("temporaryUserName");
                sessionStorage.setItem(
                    "model_paths",
                    JSON.stringify([
                        `Users/${user_id}/${file.model_id}.min.bmt`,
                    ])
                );
                navigate("/viewer");
            }}
        >
            <div>{file.model_name}</div>
            {file.progress !== 100 ? (
                <div>{file.progress} %</div>
            ) : (file as Models).version ? (
                <>
                    {showVersions && (
                        <FileVersions
                            currentFile={file as Models}
                            close={() => {
                                setShowVersions(false);
                            }}
                            update={update}
                        />
                    )}
                    <div
                        onClick={() => setShowVersions(true)}
                        className={classes.version}
                    >{`v${version}`}</div>
                </>
            ) : (
                <RemainTimeCounter
                    time={
                        new Date(file.load_date).getTime() +
                        30 * 60 * 1000 -
                        Date.now()
                    }
                ></RemainTimeCounter>
            )}
            <div>{`${
                Math.round((file.size * 100) / 1024 / 1024) / 100
            } Mb`}</div>
            <div>{getDate()}</div>
        </div>
    );
}

export default FileRow;
